import React, { useEffect, useMemo, useRef, useState } from "react";

const API_BASE = "https://rocaresteticaautomotiva.com.br";

const vehicleTypes = [
  { id: "car", label: "Carro", icon: "🚗" },
  { id: "pickup", label: "Picape", icon: "🚙" },
  { id: "truck", label: "Caminhão", icon: "🚚" },
];

function generateAvailableSlots(selectedDate) {
  const slots = [];
  const now = new Date();
  const isToday = selectedDate === now.toISOString().split("T")[0];
  for (let h = 8; h <= 17; h++) {
    if (h === 12) continue;
    for (let m of [0, 30]) {
      const hh = String(h).padStart(2, "0");
      const mm = String(m).padStart(2, "0");
      const slot = `${hh}:${mm}`;
      if (isToday) {
        const slotDate = new Date(`${selectedDate}T${slot}:00`);
        if (slotDate <= now) continue;
      }
      slots.push(slot);
    }
  }
  return slots;
}

const ALL_SLOTS = [];
for (let h = 8; h <= 17; h++) {
  if (h === 12) continue;
  for (let m of [0, 30]) {
    ALL_SLOTS.push(`${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}`);
  }
}

export default function AgendamentoArea51() {
  const canvasRef = useRef(null);

  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [date, setDate] = useState("");
  const [selectedTime, setSelectedTime] = useState("");
  const [vehicleType, setVehicleType] = useState("car");
  const [pickup, setPickup] = useState(false);
  const [address, setAddress] = useState("");
  const [notes, setNotes] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [confirmedData, setConfirmedData] = useState(null);
  const [bookedTimesForDate, setBookedTimesForDate] = useState([]);
  const [loadingSlots, setLoadingSlots] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  const [successMsg, setSuccessMsg] = useState("");

  // Canvas background animation (same as PaginaServicos)
  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    let animId;

    const resize = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    };
    resize();
    window.addEventListener("resize", resize);

    const particles = Array.from({ length: 40 }, () => ({
      x: Math.random() * window.innerWidth,
      y: Math.random() * window.innerHeight,
      r: Math.random() * 1.5 + 0.3,
      vx: (Math.random() - 0.5) * 0.3,
      vy: -(Math.random() * 0.4 + 0.1),
      life: Math.random(),
      maxLife: Math.random() * 0.5 + 0.3,
      color: Math.random() > 0.5 ? "#e8c84a" : "#ff6b35",
    }));

    const smokes = [];
    const smokeId = setInterval(() => {
      smokes.push({
        x: Math.random() * canvas.width * 0.6 + canvas.width * 0.2,
        y: canvas.height,
        r: 8 + Math.random() * 10,
        vx: (Math.random() - 0.5) * 0.6,
        vy: -(Math.random() * 0.8 + 0.4),
        alpha: 0.12 + Math.random() * 0.08,
        grow: 0.8 + Math.random() * 0.6,
      });
    }, 280);

    const loop = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      const grad = ctx.createLinearGradient(0, 0, 0, canvas.height);
      grad.addColorStop(0, "#0a0a0f");
      grad.addColorStop(1, "#0d0d1a");
      ctx.fillStyle = grad;
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      ctx.strokeStyle = "rgba(232,200,74,0.04)";
      ctx.lineWidth = 1;
      for (let x = 0; x < canvas.width; x += 40) {
        ctx.beginPath(); ctx.moveTo(x, 0); ctx.lineTo(x, canvas.height); ctx.stroke();
      }
      for (let y = 0; y < canvas.height; y += 40) {
        ctx.beginPath(); ctx.moveTo(0, y); ctx.lineTo(canvas.width, y); ctx.stroke();
      }

      for (let i = smokes.length - 1; i >= 0; i--) {
        const s = smokes[i];
        s.x += s.vx; s.y += s.vy; s.r += s.grow * 0.15; s.alpha -= 0.0015;
        if (s.alpha <= 0) { smokes.splice(i, 1); continue; }
        const sg = ctx.createRadialGradient(s.x, s.y, 0, s.x, s.y, s.r);
        sg.addColorStop(0, `rgba(180,180,200,${s.alpha})`);
        sg.addColorStop(1, "rgba(100,100,120,0)");
        ctx.fillStyle = sg;
        ctx.beginPath(); ctx.arc(s.x, s.y, s.r, 0, Math.PI * 2); ctx.fill();
      }

      particles.forEach((p) => {
        p.x += p.vx; p.y += p.vy; p.life -= 0.003;
        if (p.life <= 0 || p.y < -10) {
          p.x = Math.random() * canvas.width;
          p.y = canvas.height + 10;
          p.life = p.maxLife;
        }
        ctx.beginPath(); ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
        ctx.fillStyle = p.color; ctx.fill();
      });

      animId = requestAnimationFrame(loop);
    };
    loop();

    return () => {
      cancelAnimationFrame(animId);
      clearInterval(smokeId);
      window.removeEventListener("resize", resize);
    };
  }, []);

  // Fetch booked slots when date changes
  useEffect(() => {
    setSelectedTime("");
    setBookedTimesForDate([]);
    setError("");
    setSuccessMsg("");
    if (!date) return;

    setLoadingSlots(true);
    async function load() {
      try {
        const res = await fetch(`${API_BASE}/api/agendamentos?date=${date}`);
        const booked = await res.json();
        setBookedTimesForDate(booked.map((b) => b.time));
      } catch {
        setBookedTimesForDate([]);
      } finally {
        setLoadingSlots(false);
      }
    }
    load();
  }, [date]);

  const availableSlots = useMemo(() => {
    const free = generateAvailableSlots(date);
    return ALL_SLOTS.map((s) => ({
      time: s,
      available: free.includes(s) && !bookedTimesForDate.includes(s),
    }));
  }, [date, bookedTimesForDate]);

  function resetForm() {
    setName(""); setPhone(""); setDate(""); setSelectedTime("");
    setVehicleType("car"); setPickup(false); setAddress(""); setNotes("");
    setError(""); setSuccessMsg("");
  }

  async function handleSubmit(e) {
    e?.preventDefault();
    setError(""); setSuccessMsg("");
    if (!name.trim()) return setError("Informe o nome do cliente.");
    if (phone.replace(/\D/g, "").length < 8) return setError("Telefone inválido. Informe pelo menos 8 dígitos.");
    if (!date) return setError("Selecione a data do agendamento.");
    if (!selectedTime) return setError("Selecione o horário do agendamento.");

    const payload = { name, phone, date, time: selectedTime, vehicleType, pickup, address: pickup ? address : "", notes };
    setSaving(true);
    try {
      const res = await fetch(`${API_BASE}/api/agendamentos`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
      if (!res.ok) {
        const body = await res.json();
        throw new Error(body.error || "Erro ao salvar.");
      }
      setConfirmedData(payload);
      setShowModal(true);
      resetForm();
    } catch (err) {
      setError(err.message || "Erro desconhecido.");
    } finally {
      setSaving(false);
    }
  }

  const inputStyle = {
    width: "100%",
    boxSizing: "border-box",
    padding: "10px 12px",
    borderRadius: 10,
    border: "1px solid #2d6a2d",
    background: "#0a0a14",
    color: "#e0e0e0",
    fontSize: 13,
    outline: "none",
  };

  const cardStyle = (bg, border) => ({
    background: bg,
    border: `1px solid ${border}`,
    borderRadius: 16,
    padding: 20,
    marginBottom: 12,
  });

  const stepCircle = (color) => ({
    width: 28, height: 28, borderRadius: "50%",
    background: color, color: "#0a0a0f",
    display: "flex", alignItems: "center", justifyContent: "center",
    fontWeight: 700, fontSize: 13, flexShrink: 0,
  });

  return (
    <div style={{ minHeight: "100vh", background: "#0a0a0f", position: "relative", overflow: "hidden", fontFamily: "sans-serif" }}>

      {/* Animated canvas background */}
      <canvas ref={canvasRef} style={{ position: "fixed", top: 0, left: 0, width: "100%", height: "100%", zIndex: 0, pointerEvents: "none" }} />

      {/* Confirmation modal */}
      {showModal && confirmedData && (
        <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.75)", zIndex: 100, display: "flex", alignItems: "center", justifyContent: "center" }}>
          <div style={{ background: "#0d1b0d", border: "1px solid #2d6a2d", borderRadius: 20, padding: 28, maxWidth: 320, width: "90%", textAlign: "center" }}>
            <div style={{ fontSize: 40, marginBottom: 12 }}>✅</div>
            <h3 style={{ color: "#69db7c", margin: "0 0 14px", fontSize: 17 }}>Agendamento Confirmado!</h3>
            <div style={{ textAlign: "left", fontSize: 13, color: "#ccc", lineHeight: 1.8, marginBottom: 18 }}>
              <p style={{ margin: "4px 0" }}><strong style={{ color: "#e8c84a" }}>Cliente:</strong> {confirmedData.name}</p>
              <p style={{ margin: "4px 0" }}><strong style={{ color: "#e8c84a" }}>Telefone:</strong> {confirmedData.phone}</p>
              <p style={{ margin: "4px 0" }}><strong style={{ color: "#e8c84a" }}>Data:</strong> {new Date(confirmedData.date + "T00:00:00").toLocaleDateString("pt-BR")}</p>
              <p style={{ margin: "4px 0" }}><strong style={{ color: "#e8c84a" }}>Horário:</strong> {confirmedData.time}</p>
              <p style={{ margin: "4px 0" }}><strong style={{ color: "#e8c84a" }}>Veículo:</strong> {vehicleTypes.find(v => v.id === confirmedData.vehicleType)?.label}</p>
              {confirmedData.pickup
                ? <p style={{ margin: "4px 0" }}><strong style={{ color: "#e8c84a" }}>Buscar em:</strong> {confirmedData.address || "não informado"}</p>
                : <p style={{ margin: "4px 0" }}><strong style={{ color: "#e8c84a" }}>Entrega:</strong> Cliente leva o veículo</p>
              }
              {confirmedData.notes && <p style={{ margin: "4px 0" }}><strong style={{ color: "#e8c84a" }}>Obs:</strong> {confirmedData.notes}</p>}
            </div>
            <button
              onClick={() => setShowModal(false)}
              style={{ width: "100%", padding: "12px", borderRadius: 10, border: "none", background: "#e8c84a", color: "#0a0a0f", fontWeight: 700, fontSize: 14, cursor: "pointer" }}
            >
              OK
            </button>
          </div>
        </div>
      )}

      {/* Content */}
      <div style={{ position: "relative", zIndex: 1, maxWidth: 520, margin: "0 auto", paddingBottom: 40 }}>

        {/* Header */}
        <div style={{ textAlign: "center", padding: "28px 20px 16px" }}>
          <div style={{ width: 64, height: 64, margin: "0 auto 12px", borderRadius: "50%", background: "rgba(232,200,74,0.15)", border: "2px solid rgba(232,200,74,0.35)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 28 }}>
            🚗
          </div>
          <h1 style={{ margin: 0, fontSize: 22, fontWeight: 700, letterSpacing: 2, color: "#e8c84a" }}>ÁREA 51</h1>
          <p style={{ margin: "6px 0 0", fontSize: 13, color: "#888", letterSpacing: 1 }}>Estética Automotiva · Agende seu horário</p>
        </div>

        <div style={{ padding: "0 16px" }}>

          {/* Alert messages */}
          {error && (
            <div style={{ marginBottom: 12, padding: "12px 16px", borderRadius: 12, fontSize: 13, fontWeight: 600, background: "#3a0a0a", border: "1px solid #8a2218", color: "#ff8787" }}>
              ⚠ {error}
            </div>
          )}
          {successMsg && (
            <div style={{ marginBottom: 12, padding: "12px 16px", borderRadius: 12, fontSize: 13, fontWeight: 600, background: "#0a2a0a", border: "1px solid #2d6a2d", color: "#69db7c" }}>
              ✅ {successMsg}
            </div>
          )}

          {/* STEP 1 – Date */}
          <div style={cardStyle("linear-gradient(135deg,#0d1b2a,#1a3a5c)", "#1e4a78")}>
            <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 14 }}>
              <div style={stepCircle("#74c0fc")}>1</div>
              <span style={{ color: "#74c0fc", fontWeight: 700, fontSize: 15 }}>Selecione a Data</span>
            </div>
            <input
              type="date"
              value={date}
              onChange={(e) => setDate(e.target.value)}
              style={{ ...inputStyle, border: "1px solid #1e4a78", color: "#e8c84a", height: 44 }}
            />
          </div>

          {/* STEP 2 – Time */}
          {date && (
            <div style={cardStyle("linear-gradient(135deg,#1a0a2e,#3d1a6b)", "#5a2da0")}>
              <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 14 }}>
                <div style={stepCircle("#c77dff")}>2</div>
                <span style={{ color: "#c77dff", fontWeight: 700, fontSize: 15 }}>Selecione o Horário</span>
              </div>

              {loadingSlots ? (
                <div style={{ color: "#888", fontSize: 13, textAlign: "center", padding: "8px 0" }}>⏳ Carregando horários disponíveis...</div>
              ) : (
                <div style={{ display: "grid", gridTemplateColumns: "repeat(4,1fr)", gap: 8 }}>
                  {availableSlots.map((slot) => (
                    <button
                      key={slot.time}
                      type="button"
                      disabled={!slot.available}
                      onClick={() => slot.available && setSelectedTime(slot.time)}
                      style={{
                        padding: "9px 4px",
                        borderRadius: 10,
                        fontSize: 13,
                        fontWeight: 600,
                        cursor: slot.available ? "pointer" : "not-allowed",
                        border: selectedTime === slot.time ? "1px solid #c77dff" : slot.available ? "1px solid #5a2da0" : "1px solid #333",
                        background: selectedTime === slot.time ? "#c77dff" : slot.available ? "#1a0a2e" : "#111",
                        color: selectedTime === slot.time ? "#0a0a0f" : slot.available ? "#c77dff" : "#444",
                        textDecoration: slot.available ? "none" : "line-through",
                        transition: "all 0.2s",
                      }}
                    >
                      {slot.time}
                    </button>
                  ))}
                </div>
              )}

              {selectedTime && (
                <div style={{ marginTop: 10, padding: "10px 14px", background: "#1a3a1a", border: "1px solid #2d6a2d", borderRadius: 10, fontSize: 13, color: "#69db7c" }}>
                  ✅ Horário selecionado: <strong>{selectedTime}</strong>
                </div>
              )}
            </div>
          )}

          {/* STEP 3 – Client data */}
          {date && selectedTime && (
            <div style={cardStyle("linear-gradient(135deg,#0d1a0a,#1a3a10)", "#2d6a2d")}>
              <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 14 }}>
                <div style={stepCircle("#69db7c")}>3</div>
                <span style={{ color: "#69db7c", fontWeight: 700, fontSize: 15 }}>Seus Dados</span>
              </div>

              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10, marginBottom: 12 }}>
                <div>
                  <label style={{ display: "block", fontSize: 12, color: "#888", marginBottom: 5 }}>👤 Nome</label>
                  <input value={name} onChange={(e) => setName(e.target.value)} placeholder="Ex: João Silva" style={inputStyle} />
                </div>
                <div>
                  <label style={{ display: "block", fontSize: 12, color: "#888", marginBottom: 5 }}>📞 Telefone</label>
                  <input value={phone} onChange={(e) => setPhone(e.target.value)} placeholder="(99) 9 9999-9999" style={inputStyle} />
                </div>
              </div>

              <label style={{ display: "block", fontSize: 12, color: "#888", marginBottom: 8 }}>🚗 Tipo de Veículo</label>
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 8, marginBottom: 12 }}>
                {vehicleTypes.map((v) => (
                  <div
                    key={v.id}
                    onClick={() => setVehicleType(v.id)}
                    style={{
                      cursor: "pointer",
                      border: vehicleType === v.id ? "2px solid #e8c84a" : "1px solid #444",
                      background: vehicleType === v.id ? "rgba(232,200,74,0.13)" : "#0d0d1a",
                      borderRadius: 12,
                      padding: "12px 6px",
                      textAlign: "center",
                      transition: "all 0.2s",
                    }}
                  >
                    <span style={{ fontSize: 24, display: "block" }}>{v.icon}</span>
                    <span style={{ fontSize: 12, color: vehicleType === v.id ? "#e8c84a" : "#888" }}>{v.label}</span>
                  </div>
                ))}
              </div>

              <label style={{ display: "flex", alignItems: "center", gap: 10, cursor: "pointer", padding: 12, background: "#0a0a14", border: "1px solid #333", borderRadius: 10, marginBottom: 10 }}>
                <input
                  type="checkbox"
                  checked={pickup}
                  onChange={(e) => setPickup(e.target.checked)}
                  style={{ width: 16, height: 16, accentColor: "#e8c84a" }}
                />
                <span style={{ fontSize: 13, color: "#bbb" }}>📍 Solicitar busca do veículo</span>
              </label>

              {pickup && (
                <div style={{ marginBottom: 10 }}>
                  <input
                    value={address}
                    onChange={(e) => setAddress(e.target.value)}
                    placeholder="Rua, número, bairro, cidade"
                    style={{ ...inputStyle, border: "1px solid #444" }}
                  />
                </div>
              )}

              <label style={{ display: "block", fontSize: 12, color: "#888", marginBottom: 5 }}>💬 Observações</label>
              <textarea
                value={notes}
                onChange={(e) => setNotes(e.target.value)}
                rows={3}
                placeholder="Cuidados especiais, serviços adicionais..."
                style={{ ...inputStyle, resize: "none", border: "1px solid #333" }}
              />
            </div>
          )}

          {/* Buttons */}
          {date && selectedTime && (
            <div style={{ display: "flex", gap: 10, marginTop: 4 }}>
              <button
                type="button"
                onClick={resetForm}
                style={{ flex: 1, padding: 13, borderRadius: 12, border: "1px solid #444", background: "transparent", color: "#888", fontSize: 14, fontWeight: 600, cursor: "pointer" }}
              >
                Limpar
              </button>
              <button
                onClick={handleSubmit}
                disabled={saving}
                style={{ flex: 2, padding: 13, borderRadius: 12, border: "none", background: saving ? "#7a6820" : "linear-gradient(135deg,#e8c84a,#d4a017)", color: "#0a0a0f", fontSize: 14, fontWeight: 700, cursor: saving ? "not-allowed" : "pointer", letterSpacing: "0.5px" }}
              >
                {saving ? "Salvando..." : "✔ Confirmar Agendamento"}
              </button>
            </div>
          )}

        </div>

        {/* Footer */}
        <div style={{ textAlign: "center", padding: "24px 20px" }}>
          <p style={{ color: "#555", fontSize: 13, margin: "0 0 10px" }}>Segunda a Sábado · 8h às 18h</p>
          <a
            href="https://wa.me/555180598568"
            target="_blank"
            rel="noreferrer"
            style={{ display: "inline-block", padding: "10px 22px", background: "rgba(37,211,102,0.1)", border: "1px solid rgba(37,211,102,0.25)", borderRadius: 50, color: "#25d366", textDecoration: "none", fontSize: 13 }}
          >
            💬 Dúvidas? WhatsApp
          </a>
        </div>

      </div>
    </div>
  );
}